import { render, staticRenderFns } from "./BehaviorDropdown.vue?vue&type=template&id=feea4704&scoped=true&"
import script from "./BehaviorDropdown.vue?vue&type=script&lang=ts&"
export * from "./BehaviorDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BehaviorDropdown.vue?vue&type=style&index=0&id=feea4704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feea4704",
  null
  
)

export default component.exports